import React, {
    createContext,
    useContext,
    useEffect,
    useState,
  } from "react";
  import axios from "axios";
  
  const LandingDataContext = createContext();
  
  
  export const LandingDataProvider = ({ children }) => {
    const [landingMonthAndYear,setLandingMonthAndYear] = useState({
      month: new Date().getMonth(),
      year: new Date().getFullYear()
    })//to store the date when we move through pages.
    const fetchData = async (url,token) => {
      try {
        const response = await axios.get(url,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Replace 'YOUR_ACCESS_TOKEN' with your actual access token
            },
          }
        );
        return response.data;
      } catch (error) {
        if (error.response.status === 404) {
          return [];
        }
        console.error(`Error fetching data from ${url}:`, error);
        return null;
      }
    };
  
    const fetchMultipleApis = async (urls) => {
      const userDetails = JSON.parse(localStorage.getItem("token"));
      let token = userDetails ? userDetails.result.token : null;
      const promises = urls.map((url) => fetchData(url, token));
      return Promise.all(promises);
    };
  
    const [apiData, setApiData] = useState(null);
    useEffect(() => {
    }, [apiData]);
  
    const dataFetch = async (searchQuery) => {
      const fetchDataAndStore = async () => {
        const currentYear = new Date().getFullYear()
  
  
        const apiUrls = [
          `${process.env.REACT_APP_SERVER_BASE_URL}/transactionreports/rep/search?name=all&actual=true&startyear=${
            searchQuery.year
          }&endyear=${searchQuery.year}&startingmonth=1&endingmonth=12`,
          `${process.env.REACT_APP_SERVER_BASE_URL}/monthlyreports/search?year=${currentYear}&startingmonth=1&endingmonth=12`,
          `${process.env.REACT_APP_SERVER_BASE_URL}/monthlyreports/search?year=${currentYear-1}&startingmonth=1&endingmonth=12`
        ];
  
        try {
          const data = await fetchMultipleApis(apiUrls);
          const newData = {};
          apiUrls.forEach((url, index) => {
            newData[index] = data[index] ? data[index] : [];
          });
          setApiData(newData);
          // localStorage.setItem('monthData',JSON.stringify(newData))
        } catch (error) {
          console.error("Error fetching data from APIs:", error);
        }
      };
      fetchDataAndStore();
    };
    return (
      <LandingDataContext.Provider value={{ apiData, dataFetch, setApiData,landingMonthAndYear,setLandingMonthAndYear }}>
        {children}
      </LandingDataContext.Provider>
    );
  };
  
  export const useLandingDataContext = () => {
    return useContext(LandingDataContext);
  };
  